import {addModule, getModule} from "./Utility/ModuleUtility";
import {Environment as Env} from "./BaseEnvironments/Klimaitalia";
import {GraficaFF} from "./Modules/GraficaFF";

export var Environment = () => {
  var env= Env();
  //env = addModule(GraficaFF('#1f7aa3',null, '#1f7aa3', ),env)
  return env

}

export var environment = Environment();
